import {
  Component,
  Input,
  OnInit,
  ViewEncapsulation,
  ChangeDetectorRef,
} from '@angular/core';
import { MatSidenavContent } from '@angular/material/sidenav';
import { environment } from '../environments/environment';
import {
  NavigationEnd,
  Router,
  RouterEvent,
  Event, // Ensure this is in the list of imports from @angular/router
} from '@angular/router';
import { AuthService } from './auth.service';
import { CommonService } from './shared/service/common.service';
import { ToggleThemeService } from './shared/service/toggle-theme.service';
import { ImpersonationService } from './shared/service/impersonation.service';
/* eslint-disable */

@Component({
  selector: 'nio-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class AppComponent implements OnInit {
  noPadding = false;
  landing = false;
  showScrollButton: boolean;
  showSplash = true;
  currentApplicationVersion = environment.appVersion;

  @Input() clickHamburger: boolean;

  constructor(
    public router: Router,
    private themeService: ToggleThemeService,
    public commonService: CommonService,
    private authService: AuthService,
    private cdr: ChangeDetectorRef,
    public impersonation: ImpersonationService,
  ) {
    //check if user authenticated or not to load primary config
    this.authService.onLoad();

    router.events.subscribe((val: Event | RouterEvent) => {
      if (val instanceof NavigationEnd) {
        if (val.url.toString().startsWith('/?')) {
          this.router.navigateByUrl('/');
        }
        // Check if current page is not landing or profile page
        this.noPadding =
          val.url === '/' ||
          val.url.includes('profile') ||
          val.url.includes('web-diagram');
        this.landing = val.url === '/' || val.url.includes('web-diagram');
      }
      this.commonService.selectedHelpItem = null;
      this.commonService.selectedHelpId = null;
      if (
        this.commonService.clickHamburgerHelp.value == false ||
        !this.commonService.selectedHelpId
      ) {
        this.commonService.clickHamburgerHelp.next(true);
      }
    });
  }

  public ngOnInit() {
    this.updateSidebarState();
    window.addEventListener('resize', this.updateSidebarState.bind(this));

    this.themeService.setThemeOnStart();
    this.showScrollButton = false;
    setTimeout(() => {
      this.showSplash = false;
      this.cdr.markForCheck();
    }, 1500);
  }

  updateSidebarState() {
    const width = window.innerWidth;
    if (width < 1024 && width >= 768) {
      this.commonService.clickHamburger.next(true); // Collapse in mobile/tablet
    } else if (width <= 768) {
      this.commonService.clickHamburger.next(false); // Collapse in mobile/tablet
    } else {
      this.commonService.clickHamburger.next(false); // Expand in desktop
    }
  }

  public handleScroll(container: MatSidenavContent): void {
    const scrollTop = container.getElementRef().nativeElement.scrollTop;
    this.showScrollButton = scrollTop > 300;
  }

  onActivate(container: MatSidenavContent) {
    document.querySelector('.mat-drawer-content');
    container.scrollTo({
      left: 0,
      top: 0,
      behavior: 'smooth',
    });
  }

  isAuthorised() {
    return this.authService.isAuthenticated();
  }
}
